module.exports = __webpack_public_path__ + "static/media/power-button-ic.b480f4e6.svg";